module.exports = __webpack_public_path__ + "img/itx-file-type-message.f7931c5c.svg";